import type { HAlign } from '../types';


const anchorX = (rect: DOMRect, hAlign: HAlign): number => {
    if (hAlign === 'right')  return rect.right;
    if (hAlign === 'center') return rect.left + rect.width / 2;

    return rect.left;
};

const menuOffsetX = (menuRect: DOMRect, menuH: HAlign): number => {
    if (menuH === 'right')  return -menuRect.width;
    if (menuH === 'center') return -menuRect.width / 2;

    return 0;
};

const calcLeft = (
    triggerRect: DOMRect,
    menuRect: DOMRect,
    triggerH: HAlign,
    menuH: HAlign
): number => {
    return anchorX(triggerRect, triggerH) + menuOffsetX(menuRect, menuH);
};


export {
    calcLeft,
}
